export const SITE_LINKS = 'site-links';
export const MAX_COLUMNS = 3;
